import { useContext } from "react"
import { List } from "./list/Index"
import { Setup } from "./setup/Index"
import { ToolContext } from "../../../../core/context/ToolContext"

export const Category = ({match}) => {
    const { setup_state, tool_state } = useContext(ToolContext)
    const { categoryList } = setup_state
    const { __SESSION } = tool_state
    let loc = match.params.params

    if (loc === 'list') {
        return <List __SESSION={__SESSION}/>
    }else{
        return (
            <>
                <Setup loc={loc} categoryList={categoryList}  __SESSION={__SESSION}/>
            </>
        )
    }
}